/**
 * useComplianceStatus — account-level compliance summary for the canvas widget (TASK-555).
 * Self-fetches the honest TASK-483 summary (compliance_score is null when there's no basis).
 * Mirrors useDrift: shared key so summoned tiles dedupe with the CompliancePage overview.
 */

import { useQuery } from '@tanstack/react-query';
import { getComplianceSummary } from '../services/complianceActivityService';

export function useComplianceStatus() {
  return useQuery({
    queryKey: ['compliance-summary'],
    queryFn: () => getComplianceSummary(),
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}
